import * as React from 'react';

// components
import CrashPage from '@/components/CrashPage';

export class ErrorBoundary extends React.Component {
  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: Boolean(error) });
    this.props.logger(error, { data: errorInfo });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <CrashPage />;
    }

    return children;
  }
}
